import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileReaderEvent } from '../../GET_NEW_UI/setup-implement/setup-implement.component';
import { InterpretationService } from '../interpretation.service';
import { NotificationsService } from 'angular2-notifications';
import { TemperatureInspectionService } from '../../Temperature/temperature-inspection.service';
import { ThermographyInspectionService } from '../../Thermography/thermography-inspection.service';
import { WsreService } from '../../wsre/wsre.service';
import { AddComponentPhotoModel } from '../models/interpretation.model';

@Component({
  selector: 'app-upload-nocondition-photo',
  templateUrl: './upload-nocondition-photo.component.html',
  styleUrls: ['./upload-nocondition-photo.component.scss']
})
export class UploadNoconditionPhotoComponent implements OnInit {
  @Output() onPhotoUpload: EventEmitter<any> = new EventEmitter();
  @Input() inspectionDetailId: number;
  @Input() inspectionId: number;
  photoLoading = false;
  photo: string;
  constructor(private _interp: InterpretationService,
    private _notify: NotificationsService,
    private _cdr: ChangeDetectorRef, private _temperatureService: TemperatureInspectionService,
    private _thermogarphyService:ThermographyInspectionService,
    private _wsreService:WsreService,) { }

  ngOnInit() {
  }


  sucessfullyUploaded(title: string, message: string, image: string) {
    this._notify.success(title, message);
    this.onPhotoUpload.emit(image);
    this.photoLoading = false;
    this._cdr.detectChanges();
  }
  uploadPhoto(newPhoto: string) {
    debugger;
    this.photoLoading = true;
    this._cdr.detectChanges();
    const photo = new AddComponentPhotoModel();
    photo.InspectionId = this.inspectionId;
    photo.InspectionDetailId = this.inspectionDetailId;
    photo.NewPhoto = newPhoto;
    this.photoLoading = false;
    this._interp.updateInspectionSMUPhoto(photo.InspectionId,photo.NewPhoto).subscribe(p => {
      this.sucessfullyUploaded('Uploaded', 'SMU Photo', p.m_Item2);
      this.photoLoading = false;
    });
  }

  private compressImage(src) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        let width, height;
        width = img.width;
        height = img.height;
        console.log('width', width)
        console.log('height', height)
        var ratio = height / width; //cal aspect ratio
        let imageWidth = 800;//643
        var new_height = imageWidth * ratio; //calculate new height
        elem.width = imageWidth;
        elem.height = new_height;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, imageWidth, new_height);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }
  onSelectPhoto(event: any) {
    debugger;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (event) => {
        const imageUrl = (event.target["result"]);
        //resize photo
        this.compressImage(imageUrl).then((res: string) => {
          // console.log("imageUrl", res)
          if (res) {
           //console.log('res', res)

            //photo.NewPhoto =  this.uploadPhoto(res.split(',')[1]);
            this.uploadPhoto(res.split(',')[1]);
          }
        })

        //this.uploadPhoto(event.target.result.split(',')[1]);
      };
    }
  }

}
